import { AxiosInstance } from 'axios';

export interface ChatMessageDTO {
  id: string;
  userId: string;
  content: string;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
  user?: {
    id: string;
    username: string;
    firstName: string;
    lastName: string;
    displayName?: string;
    avatarUrl?: string;
    userType?: string;
  };
}

export interface ChatMessagesResponse {
  success: boolean;
  data: ChatMessageDTO[];
}

export interface ChatOnlineCountResponse {
  success: boolean;
  data: {
    count: number;
  };
}

export interface SendMessageParams {
  content: string;
}

export interface GetMessagesParams {
  limit?: number;
  before?: string; // ISO date string
}

export interface GetNewMessagesParams {
  after: string; // ISO date string
}

export default class ChatService {
  constructor(private axios: AxiosInstance) {}

  // 최근 메시지 조회
  getMessages = async (params?: GetMessagesParams): Promise<ChatMessagesResponse> => {
    return await this.axios.get('/chat', { params }) as any;
  };

  // 새 메시지 조회 (Polling용)
  getNewMessages = async (params: GetNewMessagesParams): Promise<ChatMessagesResponse> => {
    return await this.axios.get('/chat/new', { params }) as any;
  };

  // 메시지 전송
  sendMessage = async (params: SendMessageParams): Promise<ChatMessagesResponse> => {
    return await this.axios.post('/chat', params) as any;
  };

  // 메시지 삭제
  deleteMessage = async (id: string): Promise<{ success: boolean; message: string }> => {
    return await this.axios.delete(`/chat/${id}`) as any;
  };

  // 온라인 사용자 수
  getOnlineCount = async (): Promise<ChatOnlineCountResponse> => {
    return await this.axios.get('/chat/online-count') as any;
  };
}

